import React from 'react';
import { useParams } from 'react-router-dom';
import PlaylistForm from '../Create/PlaylistForm';

const PlaylistDetailPage = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <PlaylistForm idPlaylist={id}/>
  );
};

export default PlaylistDetailPage;